import {
  Drawer,
  useDisclosure
} from '@chakra-ui/react';
import React from 'react';
import TeacherChat from './TeacherChat';
import './ChatDrawer.css';
import '@fortawesome/fontawesome-free/css/all.min.css';


const ChatDrawer = ({ chatHistory, isLoading, userMessage, setUserMessage, sendMessage, ticker }) => {
  const { isOpen, onOpen, onClose } = useDisclosure()

  return (
    <>
      <button
        type="button"
        className='chat-tag'
        onClick={onOpen}
        aria-label="Open chat"
      >
        <i className="fas fa-comments"></i> {/* Chat icon */}
      </button>
      <Drawer.Root
        open={isOpen}
        onOpenChange={(details) => details.open ? onOpen() : onClose()}
        placement='end'
        size='md'
      >
        <Drawer.Backdrop />
        <Drawer.Positioner>
          <Drawer.Content className='content'>
            <TeacherChat
              chatHistory={chatHistory}
              isLoading={isLoading}
              userMessage={userMessage}
              setUserMessage={setUserMessage}
              sendMessage={sendMessage}
              ticker={ticker}
            />
          </Drawer.Content>
        </Drawer.Positioner>
      </Drawer.Root>
    </>
  )
}

export default ChatDrawer;
